import { type FC } from 'react';

import { SliderBlock } from 'shared/components/SliderBlock';

import { AwardCard } from './internal/components/AwardCard';
import { AwardsSources, type TAwardsSource } from './internal/components/AwardsSources';

type TAward = {
  title: string;
  imageUrl: string;
};

type TAwardsProps = {
  awardsLabel: string;
  awardsSources: TAwardsSource[];
  awards: TAward[];
  onView: () => void;
};

export const Awards: FC<TAwardsProps> = ({ awardsSources, awardsLabel, awards, onView }) => {
  return (
    <SliderBlock
      id="awards"
      sourceLabel={awardsLabel}
      sourceTooltip={<AwardsSources sources={awardsSources} />}
      title="Награды"
      onShow={onView}
    >
      {awards.map((award, index) => (
        <AwardCard image={award.imageUrl} key={index} title={award.title} />
      ))}
    </SliderBlock>
  );
};
